import { createSlice } from '@reduxjs/toolkit'

const accountOrdersSlice = createSlice({
    name: 'account-orders',
    initialState: {
        loading: false,
        error: null,
        tickets: [],
        reservations: [],
    },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        setTickets(state, action) {
            const { payload } = action
            return { ...state, tickets: payload }
        },
        setReservations(state, action) {
            const { payload } = action
            return { ...state, reservations: payload }
        },
        cancelReservation() {
            //CALLS ENDPOINT TO REMOVE RESERVATION
        },
        cancelOrder() {
            //returns tickets
        },
        getAccountOrders() {},
        payReservation() {},
        restoreToCard() {},
    },
})

const { actions, reducer } = accountOrdersSlice

export const {
    setLoading,
    setError,
    setTickets,
    cancelOrder,
    setReservations,
    getAccountOrders,
    cancelReservation,
    payReservation,
    restoreToCard,
} = actions

export default reducer
